<template>
<div>
    <h5 class="text-center mt-4 mb-3">{{ $t("SET_UP") }}</h5>
    <b-card class="setup-inner-gray py-4">
        <p>□ {{ $t("ELEMENT_4") }}</p>
        <p>□ {{ $t("PATTERN_NAME_2") }}</p>
        <p>□ {{ $t("PROJECT_NAME_1") }}</p>
        <p>□ {{ $t("GENE_IMG_NAME") }}</p>
    </b-card>
    <b-row class="mt-5">
        <b-col class="text-left">
            <b-button variant="secondary" class="px-4" @click="$emit('prev')">{{ $t("BACK_SET") }}</b-button>
        </b-col>
        <b-col class="text-right">
            <b-button variant="primary" class="px-5" @click="$emit('next')">{{ $t("NEXT") }}</b-button>
        </b-col>
    </b-row>
    <b-form-checkbox v-model="isDisabled" class="mt-3" id="checkbox-1" value="true">
     {{ $t("NOT_DIS") }}
    </b-form-checkbox>
</div>
</template>

<script>
export default {
  name: "PreviewSetupVerification",
  data() {
      return {
          isDisabled: false
      }
  },
  watch: {
      isDisabled: function(a){
          this.$emit('checkDisabledButton',a)
      }
  }
};
</script>

<style scoped>

h5 {
    font-size: 18px;
}

.setup-inner-gray {
    background-color: #EFEFEF;
    border: none;
}

</style>


// WEBPACK FOOTER //
// src/components/PreviewSetupVerification.vue